import React, { useEffect } from "react"
import { Box, Flex, Heading } from "components"
import { motion } from "framer-motion"

import Spacer from "./spacer"

function TitleCard({ next, location, project }) {
  useEffect(() => {
    // Set static viewport height unit on initial load
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
  }, [])

  return (
    <>
      <Flex
        data-component-id="titleCard"
        flexDirection="column"
        justifyContent="flex-end"
        minWidth="50vw"
        minHeight={[`calc(var(--vh, 1vh) * 50)`, null, 0]}
        py={["layout.2", "layout.4", 0]}
        px={["layout.2", "layout.4"]}
      >
        <motion.div
          variants={{
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                delay:
                  location.search.indexOf("?scroll=") !== -1 ||
                  location.search.indexOf("?topScroll=") !== -1
                    ? 0
                    : 1,
                duration:
                  location.search.indexOf("?scroll=") !== -1 ||
                  location.search.indexOf("?topScroll=") !== -1
                    ? 0
                    : 0.5,
                ease: [0.215, 0.61, 0.355, 1],
              },
            },
            initial: {
              opacity: 0,
              y: 20,
              transition: {
                when: "afterChildren",
              },
            },
          }}
          initial="initial"
          animate="visible"
          key={(next ? "next" : "") + project.title + "title"}
        >
          <Heading as="h3" size={100}>
            {[
              project.season ? project.season : undefined,
              project.agencyCredit
                ? "Agency: " + project.agencyCredit
                : undefined,
              project.creativeDirectorCredit
                ? "Creative Director: " + project.creativeDirectorCredit
                : undefined,

              project.directorCredit
                ? "Director: " + project.directorCredit
                : undefined,
              project.videoCredit ? "Video: " + project.videoCredit : undefined,
              project.photoCredit
                ? "Photography: " + project.photoCredit
                : undefined,
              project.studioPartnerCredit
                ? "Studio Partner: " + project.studioPartnerCredit
                : undefined,
            ]
              .filter(n => n)
              .join(" · ")}
          </Heading>
        </motion.div>
        <motion.div
          variants={{
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                delay:
                  location.search.indexOf("?scroll=") !== -1
                    ? 0
                    : location.search.indexOf("?mobile=") !== -1
                    ? 0.1
                    : 0.66,
                duration:
                  location.search.indexOf("?scroll=") !== -1
                    ? 0
                    : location.search.indexOf("?mobile=") !== -1
                    ? 1.4
                    : 1.4,
                ease: [0.215, 0.61, 0.355, 1],
              },
            },
            initial: {
              opacity: 0,
              y: 40,
              transition: {
                when: "afterChildren",
              },
            },
          }}
          initial="initial"
          animate="visible"
          key={(next ? "next" : "") + project.title + "meta"}
        >
          <Heading size={900} mt={["layout.2", "layout.4"]}>
            <Box as="span" display="block">
              {project.title}
            </Box>
            <Box as="span" display="block" fontFamily="serif" fontWeight={300}>
              {project.category}
            </Box>
          </Heading>
        </motion.div>
      </Flex>

      <Spacer display={["none", null, "initial"]} minWidth={16} />
    </>
  )
}

export default TitleCard
